import React, { useState, useEffect, useRef } from 'react';
import { X, Menu } from 'lucide-react';

const Navbar = ({ onCartOpen, onOperatorOpen }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const clickCountRef = useRef(0);
  const clickTimerRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const handleLogoClick = () => {
    clickCountRef.current += 1;
    if (clickTimerRef.current) clearTimeout(clickTimerRef.current);
    if (clickCountRef.current >= 5) {
      clickCountRef.current = 0;
      if (onOperatorOpen) onOperatorOpen();
      return;
    }
    clickTimerRef.current = setTimeout(() => {
      if (clickCountRef.current < 5) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      clickCountRef.current = 0;
    }, 800);
  };

  const navLinks = [
    { label: 'Tecnología', id: 'tecnologia' },
    { label: 'Diseño', id: 'diseno' },
    { label: 'Personalización', id: 'compra' },
    { label: 'Comprar', id: 'compra' },
  ];

  return (
    <>
      <nav
        data-testid="navbar"
        style={{
          position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 500,
          height: '72px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '0 48px',
        }}
      >
        <button
          onClick={handleLogoClick}
          style={{
            background: 'none', border: 'none', cursor: 'pointer',
            fontFamily: 'Inter, sans-serif', fontWeight: 700, fontSize: '16px',
            letterSpacing: '0.2em', color: '#0A0A0A',
          }}
          data-testid="navbar-logo"
        >
          ETERNA
        </button>

        <div className="desktop-only" style={{ display: 'flex', gap: '40px' }}>
          {navLinks.map(link => (
            <button
              key={link.label}
              onClick={() => scrollTo(link.id)}
              className="nav-link"
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
              data-testid={`nav-${link.label.toLowerCase()}`}
            >
              {link.label}
            </button>
          ))}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button
            className="nav-btn desktop-only"
            onClick={() => scrollTo('compra')}
            data-testid="nav-ordenar"
          >
            Comprar
          </button>
          <button
            className="mobile-only"
            onClick={() => setMenuOpen(true)}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#0A0A0A' }}
            data-testid="hamburger-btn"
          >
            <Menu size={20} />
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="mobile-menu" data-testid="mobile-menu">
          <button
            onClick={() => setMenuOpen(false)}
            style={{ position: 'absolute', top: '24px', right: '24px', background: 'none', border: 'none', cursor: 'pointer', color: '#0A0A0A' }}
          >
            <X size={24} />
          </button>
          <div style={{ fontFamily: 'Inter, sans-serif', fontWeight: 700, fontSize: '16px', letterSpacing: '0.2em', color: '#0A0A0A', marginBottom: '16px' }}>
            ETERNA
          </div>
          {navLinks.map(link => (
            <button
              key={link.label}
              onClick={() => scrollTo(link.id)}
              className="mobile-menu-link"
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('compra')}
            className="nav-btn"
            style={{ marginTop: '16px' }}
          >
            Comprar
          </button>
        </div>
      )}
    </>
  );
};

export default Navbar;
